import { faixasVigentes, listaLojas } from "../constants/lojasOnline";
import { calcularVendaOnline, unidadesDoPedido, validarVendaOnline } from "./vendaOnline";

const centavos = valor => Math.round(Number(valor) * 100);

// Compara o preço base com um preço que preserva esse valor após as taxas.
// Frete, embalagem e produção permanecem no resumo da venda: não são taxas.
export function compararPrecoComTaxas({ venda, precoBase, itens = [], lojas, maquininhas = [], hoje = new Date() }) {
  const base = Number(precoBase);
  if (!Number.isFinite(base) || base <= 0) return null;
  const calcular = precoProdutos => calcularVendaOnline({ venda, precoProdutos, itens, lojas, maquininhas, hoje });
  const resumo = preco => {
    const calc = calcular(preco);
    if (!calc) return null;
    const taxas = centavos(calc.taxaPlataforma + calc.taxaCartao) / 100;
    const recebe = centavos(calc.bruto - calc.freteCliente - taxas) / 100;
    return { preco, taxas, recebe, acrescimoCartao: calc.acrescimoCartao, reducao: Math.max(0, centavos(base - recebe) / 100) };
  };
  const manter = resumo(centavos(base) / 100);
  if (!manter) return null;
  const resultado = { base: manter.preco, manter, sugerido: null, motivo: null, manual: !!venda.taxa_manual };
  const calcBase = calcular(base);
  const erros = validarVendaOnline(venda, { ...calcBase, liquido: Math.max(0, calcBase.liquido) });
  if (erros.length) return { ...resultado, motivo: erros[0] };
  if (venda.liquido_informado !== "" && venda.liquido_informado != null) {
    return { ...resultado, motivo: "Para simular um novo preço, use o repasse calculado em vez de um valor informado." };
  }
  if (manter.reducao === 0) return { ...resultado, sugerido: { ...manter, acrescimo: 0 } };

  const baseCentavos = centavos(base);
  const limite = 100_000_000_000;
  if (baseCentavos > limite) return { ...resultado, motivo: "O preço informado ultrapassa o limite desta simulação." };
  const cortes = new Set([baseCentavos]);
  const loja = listaLojas(lojas).find(l => l.id === venda.canal);
  // Uma mudança de faixa pode fazer o líquido subir OU cair. Buscamos em
  // cada intervalo, inclusive quando itens diferentes mudam em preços distintos.
  if (loja && (venda.taxa_plataforma === "" || venda.taxa_plataforma == null)) {
    for (const unidade of unidadesDoPedido(itens, base)) {
      const proporcao = unidade.preco / base;
      if (!(proporcao > 0)) continue;
      for (const faixa of faixasVigentes(loja, hoje)) {
        if (faixa.ate == null || faixa.ate === "" || !Number.isFinite(Number(faixa.ate))) continue;
        const teto = centavos(faixa.ate);
        let corte = Math.max(1, Math.ceil((teto + 0.5) / proporcao));
        if (!Number.isSafeInteger(corte) || corte >= limite) continue;
        while (Math.round((corte - 1) * proporcao) > teto) corte--;
        while (Math.round(corte * proporcao) <= teto) corte++;
        if (corte > baseCentavos && corte < limite) cortes.add(corte);
      }
    }
  }
  const limites = [...cortes, limite + 1].sort((a, b) => a - b);
  const cobre = preco => centavos(resumo(preco / 100).recebe) >= baseCentavos;
  for (let i = 0; i < limites.length - 1; i++) {
    let baixo = limites[i], alto = limites[i + 1] - 1;
    if (!cobre(baixo)) {
      if (!cobre(alto)) continue;
      while (baixo < alto) {
        const meio = Math.floor((baixo + alto) / 2);
        if (cobre(meio)) alto = meio;
        else baixo = meio + 1;
      }
    }
    // Confere os centavos próximos por causa dos arredondamentos separados
    // da comissão e do cartão. Só entrega um preço que cobre a meta de fato.
    for (let c = Math.max(limites[i], baixo - 5); c <= baixo + 5 && c < limites[i + 1]; c++) {
      if (!cobre(c)) continue;
      const sugerido = resumo(c / 100);
      return { ...resultado, sugerido: { ...sugerido, acrescimo: (c - baseCentavos) / 100 } };
    }
  }
  return { ...resultado, motivo: "Não foi possível compensar essas taxas. Confira os percentuais e valores configurados." };
}
